import { tv } from '~/utils/tv'

export const SnackbarDescriptionVariants = tv({
  base: `
   text-text-neutral text-threeandhalfpulse !font-rdmodern font-regular
   leading-small line-clamp-2
  `,
})
